import styled, { css } from 'styled-components'

const handleFontColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#fff'
    case 'greenNarrow':
      return '#fff'
    case 'greenMoreNarrow':
      return '#fff'
    case 'greenWide':
      return '#fff'
    case 'whiteWide':
      return '#1CB954'
    case 'whiteFull':
      return '#1CB954'
    case 'red':
      return '#fff'
    case 'grey':
      return '#fff'
    case 'greyDisabled':
      return '#fff'
    case 'greyDisabledNarrow':
      return '#fff'
    case 'greyDisabledWide':
      return '#fff'
    case 'white':
      return '#1CB954'
    case 'whiteGreen':
      return '#1CB954'
    case 'whiteGreenWide':
      return '#1CB954'
    case 'whiteGreenNarrow':
      return '#1CB954'
    case 'whiteGreenMoreWide':
      return '#1CB954'
    case 'whiteGreenMoreNarrow':
      return '#1CB954'
    case 'whiteGrey':
      return '#646877'
    case 'whiteGreyDisabled':
      return '#CCCCCC'
    case 'greyBorderDisabled':
      return '#999999'
    case 'greyBorderDisabledFull':
      return '#999999'
    default:
      return '#fff'
  }
}

const handleBackgroundColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#1CB954'
    case 'greenNarrow':
      return '#1CB954'
    case 'greenMoreNarrow':
      return '#1CB954'
    case 'greenWide':
      return '#1CB954'
    case 'whiteWide':
      return '#fff'
    case 'grey':
      return '#CCCCCC'
    case 'greyDisabled':
      return '#CCCCCC'
    case 'greyDisabledNarrow':
      return '#CCCCCC'
    case 'greyDisabledWide':
      return '#CCCCCC'
    case 'greyDisabledFull':
      return '#CCCCCC'
    case 'white':
      return '#fff'
    case 'whiteGreen':
      return '#fff'
    case 'whiteGreenNarrow':
      return '#fff'
    case 'whiteGreenWide':
      return '#fff'
    case 'whiteGreenMoreWide':
      return '#fff'
    case 'whiteGreenMoreNarrow':
      return '#fff'
    case 'red':
      return '#ec5765'
    case 'redDisabled':
      return '#F7BCC1'
    case 'whiteGrey':
      return '#fff'
    case 'greyBorderDisabled':
      return '#fff'
    case 'greyBorderDisabledFull':
      return '#fff'
    default:
      return '#fff'
  }
}

const handleBorderColor = (color: string) => {
  switch (color) {
    case 'green':
      return '1px solid #1CB954'
    case 'greenNarrow':
      return '1px solid #1CB954'
    case 'greenMoreNarrow':
      return '1px solid #1CB954'
    case 'greenWide':
      return '1px solid #1CB954'
    case 'whiteWide':
      return '1px solid #646877'
    case 'whiteFull':
      return '1px solid #646877'
    case 'grey':
      return 'none'
    case 'greyDisabled':
      return '1px solid #CCCCCC'
    case 'greyDisabledNarrow':
      return '1px solid #CCCCCC'
    case 'greyDisabledWide':
      return '1px solid #CCCCCC'
    case 'greyDisabledFull':
      return '1px solid #CCCCCC'
    case 'red':
      return 'none'
    case 'white':
      return '1px solid #646877'
    case 'whiteGreen':
      return '1px solid #58B660'
    case 'whiteGreenWide':
      return '1px solid #58B660'
    case 'whiteGreenNarrow':
      return '1px solid #58B660'
    case 'whiteGreenMoreWide':
      return '1px solid #58B660'
    case 'whiteGreenMoreNarrow':
      return '1px solid #58B660'
    case 'whiteGrey':
      return '1px solid #eee'
    case 'greyBorderDisabled':
      return '1px solid #CCCCCC'
    case 'greyBorderDisabledFull':
      return '1px solid #CCCCCC'
    case 'whiteGreyDisabled':
      return '1px solid #CCCCCC'
    default:
      return '1px solid #fff'
  }
}

const handleHoverColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#fff'
    case 'greenNarrow':
      return '#fff'
    case 'greenMoreNarrow':
      return '#fff'
    case 'greenWide':
      return '#fff'
    case 'whiteWide':
      return '#1CB954'
    case 'whiteFull':
      return '#1CB954'
    case 'red':
      return '#fff'
    case 'grey':
      return '#fff'
    case 'greyDisabled':
      return '#fff'
    case 'greyDisabledNarrow':
      return '#fff'
    case 'greyDisabledWide':
      return '#fff'
    case 'greyDisabledFull':
      return '#fff'
    case 'white':
      return '#1CB954'
    case 'whiteGreen':
      return '#1CB954'
    case 'whiteGreenNarrow':
      return '#1CB954'
    case 'whiteGreenWide':
      return '#1CB954'
    case 'whiteGreenMoreWide':
      return '#1CB954'
    case 'whiteGreenMoreNarrow':
      return '#1CB954'
    case 'whiteGrey':
      return '#646877'
    case 'greyBorderDisabled':
      return '#999999'
    case 'greyBorderDisabledFull':
      return '#999999'
    default:
      return '#fff'
  }
}

const handleHoverBgColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#1CB954'
    case 'greenNarrow':
      return '#1CB954'
    case 'greenMoreNarrow':
      return '#1CB954'
    case 'greenWide':
      return '#1CB954'
    case 'whiteWide':
      return '#fff'
    case 'whiteFull':
      return '#fff'
    case 'red':
      return '#ff4861'
    case 'grey':
      return '#1db954'
    case 'greyDisabled':
      return '#CCCCCC'
    case 'greyDisabledNarrow':
      return '#CCCCCC'
    case 'greyDisabledWide':
      return '#CCCCCC'
    case 'greyDisabledFull':
      return '#CCCCCC'
    case 'white':
      return '#fff'
    case 'whiteGreen':
      return '#fff'
    case 'whiteGreenWide':
      return '#fff'
    case 'whiteGreenNarrow':
      return '#fff'
    case 'whiteGreenMoreWide':
      return '#fff'
    case 'whiteGreenMoreNarrow':
      return '#fff'
    case 'redDisabled':
      return '#F7BCC1'
    case 'whiteGrey':
      return '#fff'
    case 'greyBorderDisabled':
      return '#fff'
    case 'greyBorderDisabledFull':
      return '#fff'
    default:
      return '#1db954'
  }
}

const handlePadding = (color: string) => {
  switch (color) {
    case 'green':
      return '9.5px 40px 9.5px 40px'
    case 'greenNarrow':
      return '9.5px 24px 9.5px 24px'
    case 'greenMoreNarrow':
      return '9.5px 16px 9.5px 16px'
    case 'greenWide':
      return '9.5px 96px 9.5px 96px'
    case 'whiteWide':
      return '9.5px 96px 9.5px 96px'
    case 'red':
      return '9.5px 40px 9.5px 40px'
    case 'grey':
      return '9.5px 40px 9.5px 40px'
    case 'greyDisabled':
      return '9.5px 40px 9.5px 40px'
    case 'greyBorderDisabled':
      return '9.5px 40px 9.5px 40px'
    case 'greyDisabledNarrow':
      return '9.5px 24px 9.5px 24px'
    case 'greyDisabledWide':
      return '9.5px 96px 9.5px 96px'
    case 'greyDisabledFull':
      return '9.5px 96px 9.5px 96px'
    case 'white':
      return '9.5px 40px 9.5px 40px'
    case 'whiteGreen':
      return '9.5px 40px 9.5px 40px'
    case 'whiteGreenNarrow':
      return '9.5px 40px 9.5px 40px'
    case 'whiteGreenWide':
      return '9.5px 40px 9.5px 40px'
    case 'whiteGreenMoreWide':
      return '9.5px 47.5px 9.5px 47.5px'
    case 'whiteGreenMoreNarrow':
      return '9.5px 41.5px 9.5px 41.5px'
    case 'redDisabled':
      return '9.5px 40px 9.5px 40px'
    case 'whiteGrey':
      return '9.5px 40px 9.5px 40px'
    default:
      return '9.5px 40px 9.5px 40px'
  }
}

export const StyledButton = styled.button`
  display: ${({ color }) =>
    color === 'greyDisabledFull' || color === 'greyBorderDisabledFull'
      ? '100%'
      : 'inline-flex'};

  flex-direction: row;
  align-items: center;
  font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  outline: none;
  box-sizing: border-box;
  border: ${({ color }) => color && handleBorderColor(color)};
  border-radius: 27px;
  height: 40px;
  padding: ${({ color }) => color && handlePadding(color)};
  color: ${({ color }) => color && handleFontColor(color)};
  cursor: pointer;
  font-size: 14px;
  background: ${({ color }) => color && handleBackgroundColor(color)};
  transition: all 0.2s;
  ${({ disabled }) => {
    if (!disabled) {
      return css<{ color: string }>`
        &:hover {
          background: ${({ color }) => handleHoverBgColor(color)};
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          color: ${({ color }) => handleHoverColor(color)};
        }
        &:active {
          box-shadow: inset 0 4px 6px rgba(0, 0, 0, 0.1)};
        }
      `
    }
    return ''
  }}
  
  width: ${({ color }) =>
    color === 'greyDisabledFull' ||
    color === 'whiteFull' ||
    color === 'greyBorderDisabledFull'
      ? '100%'
      : 'auto'};
  justify-content: ${({ color }) =>
    color === 'greyDisabledFull' ||
    color === 'whiteFull' ||
    color === 'whiteGreen' ||
    color === 'greyBorderDisabledFull' ||
    color === 'greyBorderDisabled'
      ? 'center'
      : 'flex-start'};

  transition-delay: 0.3s;
`
